import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type VerifyPatientInsuranceParams =
	InsuredPatientCommandParams /* & {}*/;

export const VerifyPatientInsurance = (
	params: VerifyPatientInsuranceParams,
): Command => {
	return {
		operation: 'OverPoistenca_v6',
		params,
	};
};
